import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiMenu, FiX } = FiIcons;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false);
  };

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-black/80 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <motion.div 
            className="flex items-center gap-2 font-black text-xl tracking-tighter"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <div className="bg-gradient-to-r from-yellow-400 to-pink-500 p-1 rounded">
              <SafeIcon icon={FiZap} className="text-black w-5 h-5" />
            </div>
            <span className="text-white hidden sm:inline">NEXT LEVEL <span className="text-yellow-400">ASSISTANT</span></span>
            <span className="text-white sm:hidden">NL<span className="text-yellow-400">A</span></span>
          </motion.div>

          {/* 50+ Apps Bubble - Moved to Header */}
          <motion.div 
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.5, type: "spring", stiffness: 200 }}
            className="hidden lg:flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-pink-500 text-black px-4 py-1.5 rounded-full font-bold text-sm shadow-[0_0_15px_rgba(236,72,153,0.4)] animate-pulse"
          >
            <span>50+ AI Apps Included!</span>
            <span className="text-lg">🎯</span>
          </motion.div>
        </div>

        <nav className="hidden md:flex items-center gap-8">
          <button 
            onClick={() => scrollTo('features')} 
            className="text-sm font-medium text-gray-300 hover:text-yellow-400 transition-colors"
          >
            FEATURES
          </button>
          <button 
            onClick={() => scrollTo('apps-showcase')} 
            className="text-sm font-medium text-gray-300 hover:text-yellow-400 transition-colors"
          >
            APPS
          </button>
          <button 
            onClick={() => scrollTo('faq')} 
            className="text-sm font-medium text-gray-300 hover:text-yellow-400 transition-colors"
          >
            FAQ
          </button>
          <a 
            href="https://buy.stripe.com/4gMeVe5Ep3Ml3CK9bk6Vq04"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-yellow-400 to-pink-500 text-black px-6 py-2.5 rounded-full font-bold text-sm hover:scale-105 transition-transform"
          >
            GET ACCESS
          </a>
        </nav>

        <button 
          className="md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>
      </div>

      {isOpen && (
        <motion.div 
          className="md:hidden bg-black border-t border-gray-800 p-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex flex-col gap-4">
            {/* Mobile Badge */}
            <div className="flex justify-center mb-2">
              <div className="bg-gradient-to-r from-yellow-400 to-pink-500 text-black px-4 py-1.5 rounded-full font-bold text-sm inline-flex items-center gap-2">
                <span>50+ AI Apps Included!</span>
                <span>🎯</span>
              </div>
            </div>
            
            <button 
              onClick={() => scrollTo('features')} 
              className="text-left text-gray-300 hover:text-yellow-400 transition-colors"
            >
              Features
            </button>
            <button 
              onClick={() => scrollTo('apps-showcase')} 
              className="text-left text-gray-300 hover:text-yellow-400 transition-colors"
            >
              Apps
            </button>
            <button 
              onClick={() => scrollTo('faq')} 
              className="text-left text-gray-300 hover:text-yellow-400 transition-colors"
            >
              FAQ
            </button>
            <a 
              href="https://buy.stripe.com/4gMeVe5Ep3Ml3CK9bk6Vq04"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-yellow-400 to-pink-500 text-black p-3 text-center rounded-full font-bold"
            >
              Get Access
            </a>
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Header;